import { render, staticRenderFns } from "./35_ap_tipos_certificacion.vue?vue&type=template&id=99dae808&scoped=true&"
import script from "./35_ap_tipos_certificacion.vue?vue&type=script&lang=js&"
export * from "./35_ap_tipos_certificacion.vue?vue&type=script&lang=js&"
import style0 from "./35_ap_tipos_certificacion.vue?vue&type=style&index=0&id=99dae808&scoped=true&lang=css&"
import style1 from "./35_ap_tipos_certificacion.vue?vue&type=style&index=1&id=99dae808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dae808",
  null
  
)

export default component.exports